import { InternalServerErrorException } from '../../../../common/exceptions/exceptions';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { GetAccountWorkingHoursAverageSummaryApplicationService } from '../../../../core/application/services/org-metrics/working-hours/get-account-working-hours-average-summary.application-service';
import { AccountAverageWorkingHoursSummaryAggregateRoot } from '../../../../core/domain/aggregates/org-metrics/working-hours/account-average-working-hours-summary.aggregate-root';
import { GetAccountAverageWorkingHoursSummaryRequestDto } from '../../../dtos/org-metrics/working-hours/get-account-average-working-hours-summary.request.dto';

export class GetAccountAverageWorkingHoursSummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetAccountWorkingHoursAverageSummaryApplicationService
  ) {}
  async execute(
    props: GetAccountAverageWorkingHoursSummaryRequestDto
  ): Promise<AccountAverageWorkingHoursSummaryAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
